import React from 'react'
import SuperAdminCustomerTable from './SuperAdminCustomerTable'

const Customers = () => {
  return (
    <div>
        <SuperAdminCustomerTable name={"All Customers"}/>
    </div>
  )
}

export default Customers